var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item box-border flex flex-col flex-shrink-0 justify-end rounded-4xl overflow-hidden bg-gray-200 bg-center bg-cover relative z-1 cursor-pointer outline-solid-2",class:{
    'w-35 h-45': _vm.size === 'sm',
    'w-65 h-85': _vm.size === 'md',
    'w-full h-100': _vm.size === 'lg',
    'p-6': ['md', 'lg'].includes(_vm.size),
    'px-4 py-5': _vm.size === 'sm',
    'outline-solid-purple-500': _vm.selected,
  },style:({
    'background-image': `url(${_vm.image})`,
    color: _vm.textColor
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"absolute -z-1 w-full left-0 bottom-0 pointer-events-none",class:{
      'h-21': _vm.size === 'sm',
      'h-46': _vm.size === 'md',
      'h-52': _vm.size === 'lg',
    },style:({
      'background': `linear-gradient(to bottom, ${_vm.gradient.from}, ${_vm.gradient.to})`
    })}),(_vm.isEditMode)?_c('div',{staticClass:"handle absolute top-4 left-4"},[_c('div',{staticClass:"w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40",class:{
        'bg-black text-white': Boolean(_vm.image),
        'bg-white text-black': !Boolean(_vm.image),
      }},[_c('Icon',{attrs:{"icon":"ph:dots-six-vertical-bold","height":"16"}})],1)]):_vm._e(),(_vm.isEditMode)?_c('div',{staticClass:"absolute top-4 right-4",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('delete')}}},[_c('div',{staticClass:"w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40",class:{
        'bg-black text-white': Boolean(_vm.image),
        'bg-white text-black': !Boolean(_vm.image),
      }},[_c('Icon',{attrs:{"icon":"ph:trash","height":"16"}})],1)]):_vm._e(),_c('h3',{staticClass:"font-bold m-0 whitespace-pre-line",class:{
      'text-sm': _vm.size === 'sm',
      'text-3xl': _vm.size === 'md',
      'text-4xl': _vm.size === 'lg',
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.size !== 'sm')?_c('p',{staticClass:"text-base font-medium whitespace-pre-line m-0 mt-2"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }